export default {
  'Spot Check': 'Spot Check',
  'Nap Check': 'Nap Check',
  'Diaper Check': 'Diaper Check',
  'Health Check': 'Health Check',
  Outdoors: 'Outdoors',
  Other: 'Other'
};
